module.exports = __webpack_public_path__ + "static/media/pointToolActive.b1312cff.png";